var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.config.title,
        visible: _vm.dialogVisible,
        width: _vm.config.width,
        "append-to-body": true,
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "quick-content" }, [
        _c(
          "div",
          { staticClass: "quick-list" },
          [
            _c(
              "el-scrollbar",
              { staticStyle: { height: "50vh" } },
              [
                _c("div", { staticClass: "quick-list-item" }, [
                  _c("div", { staticClass: "quick-list-item-name" }, [
                    _vm._v("已添加"),
                  ]),
                  _vm._v(" "),
                  _vm.config.data && _vm.config.data.length > 0
                    ? _c(
                        "ul",
                        {
                          class:
                            _vm.config.type == "statistics"
                              ? "statistics"
                              : "quick-list-item-ul",
                        },
                        [
                          _c(
                            "draggable",
                            {
                              attrs: {
                                "chosen-class": "chosen",
                                "force-fallback": "true",
                                group: "people",
                                animation: "800",
                                "ghost-class": "ghost",
                              },
                              on: { start: _vm.onStart, end: _vm.onEnd },
                              model: {
                                value: _vm.config.data,
                                callback: function ($$v) {
                                  _vm.$set(_vm.config, "data", $$v)
                                },
                                expression: "config.data",
                              },
                            },
                            [
                              _vm.config.type == "statistics"
                                ? _c(
                                    "transition-group",
                                    _vm._l(
                                      _vm.config.data,
                                      function (item, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index,
                                            staticClass: "statistics-item",
                                          },
                                          [
                                            _c("div", { staticClass: "name" }, [
                                              _vm._v(_vm._s(item.title)),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "num" }, [
                                              _vm._v("0.00"),
                                            ]),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-remove quick-icon remove",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemove(index)
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c(
                                    "transition-group",
                                    _vm._l(
                                      _vm.config.data,
                                      function (item, index) {
                                        return _c(
                                          "li",
                                          { key: index },
                                          [
                                            [
                                              _c("el-image", {
                                                staticClass: "image",
                                                attrs: { src: item.image },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "name" },
                                                [_vm._v(_vm._s(item.name))]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-remove quick-icon remove",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleRemove(
                                                      index
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "quick-list-empty" }, [
                        _vm._v("陀螺匠会更努力了解你的需求"),
                      ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.fastEntryData, function (other, index) {
                  return [
                    _c("div", { staticClass: "quick-list-item" }, [
                      _c("div", { staticClass: "quick-list-item-name" }, [
                        _vm._v(_vm._s(other.cate_name)),
                      ]),
                      _vm._v(" "),
                      _vm.config.type == "statistics"
                        ? _c(
                            "ul",
                            { staticClass: "statistics" },
                            _vm._l(other.fast_entry, function (item1, indexs) {
                              return _c(
                                "li",
                                {
                                  key: "item1" + indexs,
                                  staticClass: "statistics-item",
                                },
                                [
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v(_vm._s(item1.title)),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "num" }, [
                                    _vm._v("0.00"),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.selectIds.includes(item1.id)
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-circle-plus quick-icon default-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePush(item1)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          )
                        : _c(
                            "ul",
                            { staticClass: "quick-list-item-ul" },
                            _vm._l(other.fast_entry, function (item1, indexs) {
                              return _c(
                                "li",
                                { key: "item1" + indexs },
                                [
                                  _c("el-image", {
                                    staticClass: "image",
                                    attrs: { src: item1.image },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v(_vm._s(item1.name)),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.selectIds.includes(item1.id)
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-circle-plus quick-icon default-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePush(item1)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                    ]),
                  ]
                }),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("public.ok")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }